import { useCallback, useMemo } from 'react'
import { useFetch, useSuccessNotification } from 'civic-champs-shared/api/hooks'

export default function useResendInvitation(onSuccess) {
  const [request, { loading, error, result }] = useFetch(
    'Error resending invitation.  Please refresh the page to try again',
  )
  const showSuccess = useSuccessNotification()
  const resendInvitation = useCallback(
    invitation => {
      return request({
        method: 'post',
        url: `/invitations/${invitation.id}/resend`,
        onSuccess: (result) => {
          showSuccess('Successfully resent invitation')
          onSuccess && onSuccess(result)
        },
      })
    },
    [request, showSuccess, onSuccess],
  )

  return useMemo(
    () => [
      resendInvitation,
      {
        loading,
        error,
      },
    ],
    [loading, error],
  )
}
